// @ngInject
function smartDecimal() {
    var DECIMAL_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/;  // Matches: 1.123,56
    var DECIMAL_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/;  // Matches: 1,123.56
    var DECIMAL_REGEXP_3 = /^\$?\d+(\.\d*)?$/;          // Matches: 1123.56
    var DECIMAL_REGEXP_4 = /^\$?\d+(\,\d*)?$/;          // Matches: 1123,56

    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function(viewValue) {
                if (DECIMAL_REGEXP_1.test(viewValue)) {
                    ctrl.$setValidity('decimal', true);
                    return parseFloat(viewValue.replace('.', '').replace(',', '.'));
                } else if (DECIMAL_REGEXP_2.test(viewValue)) {
                    ctrl.$setValidity('decimal', true);
                    return parseFloat(viewValue.replace(',', ''));
                } else if (DECIMAL_REGEXP_3.test(viewValue)) {
                    ctrl.$setValidity('decimal', true);
                    return parseFloat(viewValue);
                } else if (DECIMAL_REGEXP_4.test(viewValue)) {
                    ctrl.$setValidity('decimal', true);
                    return parseFloat(viewValue.replace(',', '.'));
                } else {
                    ctrl.$setValidity('decimal', false);
                    return undefined;
                }
            });
        }
    };
}

angular
    .module('directives.smartDecimal', [])
    .directive('smartDecimal', smartDecimal);
